const ru = {
  titles: {
    contactUs: 'Связь с нами',
    addQuestion: 'Добавление вашего вопроса',
  },
};

export default ru;
